// extracted by mini-css-extract-plugin
export default {"list":"GvOJ2ll42D5l6NW40r8f","row":"DhW6SEPCOiTLbSrZqKZX"};